module.exports = __webpack_public_path__ + "static/img/申请试用.9510bcb.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/Teams/申请试用.png
// module id = VGQe
// module chunks = 1